/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import Grid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  setContactTypeDataChangeTried,
  setContactTypeDataRowSelected,
  setContactTypeErrorMessage,
  setContactTypeSuccessMessage,
  updateParentUserId,
} from '../store/actions';
import ContactTypeCustomTextField from './ContactTypeCustomTextField';
import { KEY_TYPE_TABLE_HEAD } from './tableHead';

const KeyTypeTable = ({
  contactTypeSearchResult,
  selectedParentKey,
  childContactTypeError,
  fullScreen,
  setFullScreen,
  isReadOnly,
}) => {
  const dispatch = useDispatch();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [gridApi, setGridApi] = useState(null);
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);

  const handleBlur = (props, compareContactTypeResult) => {
    if (props) {
      const index = compareContactTypeResult.findIndex(
        (item) =>
          item.codeValueVO.codeValue === props.data.codeValueVO.codeValue
      );

      if (index !== -1) {
        const result = compareContactTypeResult[index].codeValueVO;

        if (
          props.data.codeValueVO.longDescription !== result.longDescription ||
          props.data.codeValueVO.shortDescription !== result.shortDescription
        ) {
          dispatch(updateParentUserId(index, logInUser));
        } else {
          dispatch(
            updateParentUserId(index, result.lastUpdateUserId || logInUser)
          );
        }
      }
    }

    dispatch(setContactTypeDataChangeTried(Math.random()));
    dispatch(setContactTypeSuccessMessage(''));
  };

  const hightlightSelectedRow = (domainKey) => {
    if (gridApi) {
      gridApi.forEachNode((node) => {
        if (node.data.codeValueVO.codeValue === domainKey) {
          node.setSelected(true);
        }
      });
    }
  };

  useEffect(() => {
    if (gridApi && selectedParentKey) {
      setTimeout(() => {
        hightlightSelectedRow(selectedParentKey.codeValueVO.codeValue);
      }, 0);
    }
  }, [gridApi, selectedParentKey]);

  const handleFullScreenView = () => {
    setFullScreen(!fullScreen);
  };

  const handleViewHistory = (gridsApi) => {
    const selectedRow = gridsApi.getSelectedRows()?.[0]?.contactTypeCdVO?.[0];
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        CONTACT_TYPE_CD: `${selectedRow?.contactTypeCd}`,
        KEY_TYPE_CD: `${selectedRow?.keyTypeCd}`,
      });
    }
  };

  return (
    <div
      className={`table-container fourRecords no-border mt-${
        fullScreen ? 1 : 3
      }`}
    >
      <Grid
        gridHeight={fullScreen ? '70vh' : 360}
        rowData={contactTypeSearchResult}
        defaultCol={{ editable: false }}
        columnDefs={KEY_TYPE_TABLE_HEAD}
        frameworkComponents={{
          textFieldComponent: (props) => (
            <ContactTypeCustomTextField
              {...props}
              validateBtnDisable={handleBlur}
              isReadOnly={isReadOnly}
            />
          ),
        }}
        onSelect={(e) => {
          if (!childContactTypeError) {
            dispatch(setContactTypeDataRowSelected(e.data));
            dispatch(setContactTypeSuccessMessage(''));
            dispatch(setContactTypeErrorMessage(''));
          } else {
            hightlightSelectedRow(selectedParentKey.codeValueVO.codeValue);
          }
        }}
        fullScreenView={fullScreen}
        handleFullScreenViewClick={handleFullScreenView}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        handleViewHistory={handleViewHistory}
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        exportFile
        data-testid='onEditingStopped'
        fileName='Key Type Table'
      />
      {selectedParentKey && (
        <span className='mt-1 text-black'>{`Contact Type for key type '${selectedParentKey.codeValueVO.codeValue}'`}</span>
      )}

      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='CODE_VALUE'
          keyValue={keyValue}
          columnNames='SHORT_DESCR,LONG_DESCR'
        />
      ) : null}
    </div>
  );
};

export default KeyTypeTable;
